import { MonoTypeOperatorFunction } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

export function distinctUntilNullableKeyChanged<T>(key: keyof T): MonoTypeOperatorFunction<T> {
  return distinctUntilChanged<T>((a: T, b: T) => {
    if (a === b) {
      return true;
    }
    if (a && b && a[key] === b[key]) {
      return true;
    }
    return false;
  });
}
